// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"79d655b2","63":"23e7b248","270":"0e1fb5fa","302":"51826b34","364":"364590a1","453":"ec3ecd73","650":"b951f6a8","794":"95e16a6d"}[chunkId] + ".chunk.js";
};